"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateClientAccountRequestToJSON = exports.UpdateClientAccountRequestFromJSONTyped = exports.UpdateClientAccountRequestFromJSON = exports.instanceOfUpdateClientAccountRequest = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the UpdateClientAccountRequest interface.
 */
function instanceOfUpdateClientAccountRequest(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfUpdateClientAccountRequest = instanceOfUpdateClientAccountRequest;
function UpdateClientAccountRequestFromJSON(json) {
    return UpdateClientAccountRequestFromJSONTyped(json, false);
}
exports.UpdateClientAccountRequestFromJSON = UpdateClientAccountRequestFromJSON;
function UpdateClientAccountRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'clientName': !(0, runtime_1.exists)(json, 'client_name') ? undefined : json['client_name'],
        'contactEmailAddress': !(0, runtime_1.exists)(json, 'contact_email_address') ? undefined : json['contact_email_address'],
    };
}
exports.UpdateClientAccountRequestFromJSONTyped = UpdateClientAccountRequestFromJSONTyped;
function UpdateClientAccountRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'client_name': value.clientName,
        'contact_email_address': value.contactEmailAddress,
    };
}
exports.UpdateClientAccountRequestToJSON = UpdateClientAccountRequestToJSON;
